export enum BuilderGenerationStatus {
  NOT_REQUESTED = 'not_requested',
  REQUESTED = 'requested',
  IN_PROGRESS = 'in_progress',
}
